const REPORT_LAYOUT_MUTATIONS: MutationObserverInit = {
  subtree: true,
  childList: true,
  characterData: true,
  attributes: true,
  attributeFilter: [
    "src",
    "style",
    "class",
    "data-report-layout-pending",
    "data-report-layout-failed",
  ],
};

function measurementState(container: HTMLElement): string {
  const sizes = Array.from(container.children).map((section) => {
    const element = section as HTMLElement;
    return `${element.offsetWidth}:${element.offsetHeight}`;
  });
  const images = Array.from(container.querySelectorAll("img")).map(
    (image) =>
      `${image.currentSrc || image.src}:${image.complete}:${
        image.naturalHeight
      }`
  );
  return JSON.stringify([
    sizes,
    images,
    document.fonts.status,
    container.querySelectorAll('[data-report-layout-pending="true"]').length,
    container.querySelectorAll('[data-report-layout-failed="true"]').length,
  ]);
}

function subscribeToReportAssets(
  container: HTMLElement,
  changed: () => void
): () => void {
  container.addEventListener("load", changed, true);
  container.addEventListener("error", changed, true);
  document.fonts.addEventListener("loading", changed);
  document.fonts.addEventListener("loadingdone", changed);
  document.fonts.addEventListener("loadingerror", changed);
  return () => {
    container.removeEventListener("load", changed, true);
    container.removeEventListener("error", changed, true);
    document.fonts.removeEventListener("loading", changed);
    document.fonts.removeEventListener("loadingdone", changed);
    document.fonts.removeEventListener("loadingerror", changed);
  };
}

/** Late media mounts and font/layout changes must revoke a previously settled layout. */
export function observeReportLayout(
  container: HTMLElement,
  onChange: () => void
): () => void {
  let previous = measurementState(container);
  const changed = () => {
    const current = measurementState(container);
    if (current === previous) return;
    previous = current;
    onChange();
  };
  return subscribeToReportLayout(container, changed);
}

function subscribeToReportLayout(
  container: HTMLElement,
  changed: () => void
): () => void {
  const mutations = new MutationObserver(changed);
  const sizes = new ResizeObserver(changed);
  mutations.observe(container, REPORT_LAYOUT_MUTATIONS);
  Array.from(container.children).forEach((section) => sizes.observe(section));
  sizes.observe(container);
  const unsubscribeAssets = subscribeToReportAssets(container, changed);
  return () => {
    mutations.disconnect();
    sizes.disconnect();
    unsubscribeAssets();
  };
}
